import {Options} from "highcharts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export interface LegendSettings {
    improvableLabel: string;
    favorableLabel: string;
    veryFavorableLabel: string;
}

export interface ChartSettings {
    yAxisTitle: {
        text: string;
    };
    legend: LegendSettings;
}

export class BaseChart extends AbstractChart {
    protected allChartOptions(): Options {
        const customSettings: ChartSettings = $(this.target).data("chart-settings");
        const options: Options = {
            chart: {
                width: 650,
                height: 417,
                spacingLeft: 0,
                spacingTop: 5,
                marginLeft: 220,
                marginBottom: 20,
                events: undefined
            },
            xAxis: {
                labels: {
                    enabled: false,
                    useHTML: true,
                    style: {
                        color: 'black'
                    }
                },
                plotLines: [
                    {
                        color: '#C0C0C0',
                        value: 9.52,
                        width: 2
                    }
                ]
            },
            yAxis: {
                opposite: true,
                offset: -9,
                title: {
                    text: customSettings.yAxisTitle.text,
                    style: {
                        color: 'black',
                        fontWeight: 'normal',
                        fontSize: '14px'
                    },
                    offset: 37
                },
                labels: {
                    style: {
                        color: 'black',
                        fontSize: '14px'
                    }
                }
            }
        };
        
        return super.mergeOptions(super.allChartOptions(), options);
    }

    protected addBarLabels(data: Array<any>, renderer: any): void {
        for (let i = 0; i < data.length; i++) {
            const number = data[i]['number'];
            const title = data[i]['label'];
            const isLongLabel = (title.length > 43);
            if (number > 0) {
                renderer.text(number, 25, (74.5 + (i * 31.1)))
                    .attr({
                        align: 'right'
                    })
                    .css({
                        fontSize: '14px',
                        fontWeight: 'bold'
                    })
                    .add();
            }
            if (isLongLabel) {
                renderer.label(title, 35, (51.7 + (i * 31.0)))
                    .attr({
                        class: 'label-small'
                    })
                    .css({
                        fontSize: '7pt',
                        width: '150pt'
                    })
                    .add();
            } else {
                renderer.label(title, 35, (58.7 + (i * 31.0)))
                    .attr({
                        class: 'label-small'
                    })
                    .css({
                        fontSize: '7pt'
                    })
                    .add();
            }
        }
    }
}